import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";

const getToken = () => "LiveBearer " + localStorage.getItem("auth-token");

const initialState = {
  loaded: false,
  loading: false,
  generations: [],
  shiftConf: [],
  lineDetails: null,
  workingDealers: [],
  assignments: [],
  studios: [],

  error: { status: false, message: "" },
  success: { status: false, message: "" },
};

export const getGenerations = createAsyncThunk(
  "linesGeneration/getLines",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get("/line-generation/", {
        headers: { "x-auth": getToken() },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const generateLines = createAsyncThunk(
  "linesGeneration/generateLines",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post("/line-generation/", data, {
        headers: { "x-auth": getToken() },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getGenerationDetails = createAsyncThunk(
  "linesGeneration/getLineDetails",
  async (generationId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/line-generation/${generationId}`, {
        headers: { "x-auth": getToken() },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getDateAssigmentments = createAsyncThunk(
  "linesGeneration/getDateAssigmentments",
  async (postData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/line-generation/assignments`, postData, {
        headers: { "x-auth": getToken() },
      });
      return res.data; 
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteLineGeneration = createAsyncThunk(
  "linesGeneration/deleteLine",
  async (generationId, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/line-generation/${generationId}`, {
        headers: { "x-auth": getToken() },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const linesGenerationSlice = createSlice({
  name: "linesGeneration",
  initialState,
  reducers: {
    reset(state) {
      state.error = { status: false, message: "" };
      state.success = { status: false, message: "" };
    },
    clearLineDetails(state) {
      state.lineDetails = null;
      state.games = [];
      state.studios = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGenerations.pending, (state) => {
      state.loading = true;
      state.error = { status: false, message: "" };
      state.success = { status: false, message: "" };
    });
    builder.addCase(getGenerations.fulfilled, (state, action) => {
      const data = action.payload;

      state.loading = false;
      state.loaded = true;
      state.generations = data.lgs|| [];
      state.shifts = data.shifts || [];
    });
    builder.addCase(getGenerations.rejected, (state, action) => {
      state.loading = false;
      state.error = {
        status: true,
        message: action.payload?.message || action.payload || action.error.message,
      };
    });

    builder.addCase(generateLines.fulfilled, (state, action) => {
      state.generations = [...state.generations, action.payload];
    })
    builder.addCase(getGenerationDetails.pending, (state) => {
      state.loading = true;
      state.error = { status: false, message: "" };
    });
    builder.addCase(getGenerationDetails.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload || {};
      state.shiftConf = payload.shiftConf ?? payload;
    });
    builder.addCase(getGenerationDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = {
        status: true,
        message: action.payload?.message || action.payload || action.error.message,
      };
    });

    builder.addCase(getDateAssigmentments.pending, (state) => {
      state.loading = true;
      state.error = { status: false, message: "" };
      state.success = { status: false, message: "" };
    });
    builder.addCase(getDateAssigmentments.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload || {};
      state.workingDealers = payload.workingDealers ?? [];
      state.assignments = payload.assignments ?? [];
      // state.lineDetails = payload.line ?? payload;

      // if (state.lineDetails?.id) {
      //   state.lines = state.lines.map((l) =>
      //     l.id === state.lineDetails.id ? { ...l, ...state.lineDetails } : l
      //   );
      // }

      state.success = { status: true, message: "Line updated successfully" };
    });
    builder.addCase(getDateAssigmentments.rejected, (state, action) => {
      state.loading = false;
      state.error = {
        status: true,
        message: action.payload?.message || action.payload || action.error.message,
      };
    });

    builder.addCase(deleteLineGeneration.pending, (state) => {
      state.loading = true;
      state.error = { status: false, message: "" };
      state.success = { status: false, message: "" };
    });
    builder.addCase(deleteLineGeneration.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      state.generations = data.lgs;
      state.shifts = data.shifts;
      // if (state.lineDetails?.id === deletedId) {
      //   state.lineDetails = null;
      //   state.games = [];
      //   state.studios = [];
      // }

      state.success = { status: true, message: "Line Generation is deleted successfully!" };
    });
    builder.addCase(deleteLineGeneration.rejected, (state, action) => {
      state.loading = false;
      state.error = {
        status: true,
        message: action.payload?.message || action.payload || action.error.message,
      };
    });
  },
});

export const linesGenerationActions = linesGenerationSlice.actions;
export const linesGenerationReducer = linesGenerationSlice.reducer;
